/**
 * Sorte aktualisieren anhand der KulturID
 * @param element
 * @returns {boolean}
 */
import axios from 'axios';

window.updateSorte = function(element) {
    var kulturVal = $(element).val();

    var sorteSelect = document.getElementById('filter-sorte'), i;
    sorteSelect.selectedIndex = 0;
    for (i = 0; i < sorteSelect.length; i++) {
        if (kulturVal == 0) {
            $(sorteSelect[i]).show();
        } else {
            if (sorteSelect[i].getAttribute('data-kultur-code') == 0 || sorteSelect[i].getAttribute('data-kultur-code') == kulturVal) {
                $(sorteSelect[i]).show();
            } else {
                $(sorteSelect[i]).hide();
            }
        }
    }

    return false;
};

/**
 * selectRow
 * @param element
 */
window.selectRow = function(element) {
    let selectedRow = $(element);
    var sorteId = selectedRow.data('sorteId');
    var rowTable = selectedRow.closest('div.row-table');
    $(rowTable).find('div.row').each(function() {
        if ($(this).data('sorteId') === sorteId) {
            var checkbox = $(this).find('input:checkbox.select-biobestand');
            var current = checkbox.prop('checked');
            $(checkbox).prop('checked', !current);
            $(this).toggleClass('selected');
        }
    });
    checkRows();
};

/**
 * checkRows
 */
window.checkRows = function() {
    var hasSelectedRows = false;
    $('input:checkbox.select-biobestand').each(function() {
        if ($(this).prop('checked') === true) {
            hasSelectedRows = true;
        }
    });

    $('.druck_ausnahmegenehmigung').prop('disabled', !hasSelectedRows);
};

/**
 * Ausnahmegenehmigung für ausgewählte Zeilen drucken
 * @param canEdit
 */
window.druckPDF = function(canEdit) {
    var ids = [];
    var i = 0;
    $('input:checkbox:checked.select-biobestand').each(function() {

        var row = $(this).closest('div.row');
        var sorte = $(row).attr('data-sorte-id');
        if (ids.indexOf(sorte) === -1) {
            ids[i] = sorte;
            i++;
        }
    });
    if (canEdit) {
        ajaxDialog(BASE_PATH + 'ajax/dialog/druckAusnahmegenehmigung?sorten=' + ids.join(), 400);
    } else {
        window.open(BASE_PATH + 'export/pdf/pdf.ausdruckAusnahmegenehmigung?sorten=' + ids.join());
    }
};

/**
 * Biopflanzmaterial Uploader
 */
window.biopflanzmaterialFileUploader = function(lang) {
    var fileInput = document.getElementById('filePflanzgutregelung_' + lang);

    document.getElementById('progress-filePflanzgutregelung_' + lang).style.display = 'none';

    fileInput.addEventListener('change', function(event) {
        var files = event.target.files;
        if (files.length > 0) {
            fileInput.setAttribute('disabled', 'disabled');
            document.getElementById('save-upload-form').setAttribute('disabled', 'disabled');

            document.getElementById('progress-filePflanzgutregelung_' + lang).style.display = 'block';
            document.querySelector('#progress-filePflanzgutregelung_' + lang + ' .progress-bar').style.width = '0%';
            document.querySelector('#progress-filePflanzgutregelung_' + lang + ' div.progress-text').innerHTML = 'Bitte warten...';

            const formData = new FormData();
            formData.append('file', files[0]); // Hier nur das erste ausgewählte File
            formData.append('lang', lang);
            axios.post(MP_PATH + 'sbr/biopflanzmaterial/ajax/helper/uploadFiles', formData).then(function(response) {
                var progress = parseInt('100', 10);

                document.querySelector('#progress-filePflanzgutregelung_' + lang + ' .progress-bar').style.width = progress + '%';
                if (response.data.success === true) {
                    document.querySelector('#progress-filePflanzgutregelung_' + lang + ' div.progress-text').innerHTML = '<strong>Fertig!</strong>';
                    document.getElementById('save-upload-form').removeAttribute('disabled');
                    fileInput.removeAttribute('disabled');
                    if (document.getElementById('file_' + lang) !== null) {
                        document.getElementById('file_' + lang).href = 'pdfDownload?pflanzgutregelung&tmp&file=' + response.data.filename;
                        document.getElementById('file_' + lang).innerHTML = '&raquo; ' + response.data.filename;
                    }
                    document.getElementById('fileInput_' + lang).value = response.data.filename;
                }
            }).catch(function(error) {
                // Fehlerbehandlung
                console.error('Fehler beim Hochladen der Datei:', error);
            });
        }
    });
};
/**
 * handleSettings
 */
window.handleSettings = function(elem) {
    let data;
    if ($(elem).is(':checkbox')) {
        data = {
            selected: ($(elem).is(':checked') ? 1 : 0),
        };
    } else {
        data = {
            date: ($(elem).val()),
            baumschuleID: document.getElementById('filter-baumschule').value,
        };
    }
    $.ajax({
        type: 'post',
        url: MP_PATH + 'sbr/biopflanzmaterial/ajax/helper/handleSettings',
        data: data,
        success: function(res) {
            console.log(res);
        },
    });
};

/**
 *
 * @param element
 */
window.biopflanzmaterialCheckSelectAll = function(element) {
    const checked = $(element).prop('checked');
    let selectAllElement = document.getElementById('selectAll');

    if (parseInt($(element).val()) === 0) {
        // selectAll
        $(element).removeClass('inderterminate');
        $('input:checkbox.select-biobestand').prop('checked', checked);
        updateDisabledButtons(checked);
    } else {
        // andere Checkbox
        let allChecked = true;
        let hasCheckedItems = false;
        $('input:checkbox.select-biobestand').each(function() {
            if ($(this).prop('checked') === false) {
                allChecked = false;
            } else {
                hasCheckedItems = true;
            }
        });

        if (allChecked) {
            selectAllElement.classList.remove('inderterminate');
            selectAllElement.checked = true;
            updateDisabledButtons(true);
        } else {
            if (hasCheckedItems) {
                selectAllElement.checked = false;
                selectAllElement.classList.add('inderterminate');
                updateDisabledButtons(true);
            } else {
                selectAllElement.classList.remove('inderterminate');
                selectAllElement.checked = false;
                updateDisabledButtons(false);
            }
        }
    }
};

/**
 * Öffnet einen Dialog zur Änderung des Bestandsdatums.
 * Diese Funktion sammelt die IDs der ausgewählten Bestände und öffnet einen Dialog, um das Datum dieser Bestände zu ändern.
 * Wenn die Option "Alle auswählen" aktiviert ist, wird die ID 'ALL' verwendet.
 */
window.openBestanddatumAendern = function() {
    let selectedBestandIDs = [];

    // Alle Checkboxen mit der Klasse 'select-biobestand', die angehakt sind
    document.querySelectorAll('input.select-biobestand[type="checkbox"]:checked').forEach(function(checkbox) {
        selectedBestandIDs.push(checkbox.value);
    });

    // Wenn "Select All" Checkbox aktiv ist
    if (document.getElementById('selectAll')?.checked) {
        selectedBestandIDs = ['ALL'];
    }

    ajaxDialog(BASE_PATH + 'ajax/dialog/bestanddatumAendern?bestandIDs=' + selectedBestandIDs.join());
};

/**
 * changeVisibility
 */
window.changeVisibility = function(biobestandID, element) {
    $.ajax({
        type: 'post',
        url: BASE_PATH + 'ajax/helper/handleVisibility',
        data: {
            biobestandID: biobestandID,
        },
        success: function(res) {
            let klassenname = 'material-icons';
            if (res === 'false') {
                klassenname += '-outlined';
            }
            $(element).attr('class', klassenname);
        },
    });
};

/**
 * matchSelectOptions
 */
window.matchSelectOptions = function() {
    document.getElementById('a_hs_code').addEventListener('change', function() {
        let value = document.getElementById('a_hs_code').value;
        $.ajax({
            type: 'post',
            url: BASE_PATH + 'ajax/helper/matchSelectOptions',
            data: {
                kulturart: value,
            },
            success: function(res) {
                let items = JSON.parse(res);
                let selectElement = document.getElementById('a_sorte_code');
                selectElement.options.length = 1;
                let children = items.map(item => new Option(item.label, item.value));
                children.forEach(child => selectElement.appendChild(child));
                if (value > 0) {
                    selectElement.removeAttribute('disabled');
                } else {
                    selectElement.setAttribute('disabled', true);
                    let selectKlonElement = document.getElementById('a_klon_code');
                    selectKlonElement.value = '';
                    selectKlonElement.setAttribute('disabled', true);
                }
            },
        });
    });
    document.getElementById('a_sorte_code').addEventListener('change', function() {
        let value = document.getElementById('a_sorte_code').value;
        $.ajax({
            type: 'post',
            url: BASE_PATH + 'ajax/helper/matchSelectOptions',
            data: {
                sorte: value,
            },
            success: function(res) {
                let items = JSON.parse(res);
                let selectElement = document.getElementById('a_klon_code');
                selectElement.options.length = 1;
                let children = items.map(item => new Option(item.label, item.value));
                children.forEach(child => selectElement.appendChild(child));
                if (value > 0) {
                    selectElement.removeAttribute('disabled');
                } else {
                    selectElement.setAttribute('disabled', true);
                }
            },
        });
    });
    document.getElementById('a_unterlage_code').addEventListener('change', function() {
        let value = document.getElementById('a_unterlage_code').value;
        $.ajax({
            type: 'post',
            url: BASE_PATH + 'ajax/helper/matchSelectOptions',
            data: {
                unterlage: value,
            },
            success: function(res) {
                let items = JSON.parse(res);
                let selectElement = document.getElementById('a_unterlagenklon_id');
                selectElement.options.length = 1;
                let children = items.map(item => new Option(item.label, item.value));
                children.forEach(child => selectElement.appendChild(child));
                if (value > 0) {
                    selectElement.removeAttribute('disabled');
                } else {
                    selectElement.setAttribute('disabled', true);
                }
            },
        });
    });
};

/**
 * finalizeBestaende
 */
window.finalizeBestaende = function() {
    let baumschuleID = document.getElementById('filter-baumschule').value;
    let isSelectAll = document.getElementById('selectAll').checked;
    let rows = [];
    $('input:checkbox.select-biobestand').each(function() {
        if ($(this).prop('checked') === true) {
            rows.push($(this).val());
        }
    });
    if (rows.length > 0) {
        $.ajax({
            type: 'post',
            url: BASE_PATH + 'ajax/helper/finalizeBestaende',
            data: {
                baumschule: baumschuleID,
                selectAll: isSelectAll === true ? 1 : 0,
                rows: rows.join(','),
            },
            success: function() {
                ListBiobestandAendern.updater({});
                ListBiobestandAendernAktuell.updater({});
            },
        });
    }
};

/**
 * updateBiobestandAktuellListe
 */
window.updateBiobestandAktuellListe = function() {
    document.getElementById('filter-baumschule').addEventListener('input', function() {
        ListBiobestandAendernAktuell.updater({'baumschule': document.getElementById('filter-baumschule').value});
    });
};

/**
 * updateDisabledButtons
 */
window.updateDisabledButtons = function(isEnabled) {
    let buttons = document.getElementsByClassName('edit-bestand');

    for (let i = 0; i < buttons.length; i++) {
        if (isEnabled) {
            buttons[i].removeAttribute('disabled');
        } else {
            buttons[i].setAttribute('disabled', true);
        }
    }
};
